import Alpine from 'alpinejs';

Alpine.data('GridHelper', () => ({

    GridActive: false,

    init(){

        this.GridActive = localStorage.getItem( 'grid-helper-active' ) === 'true';

        document.addEventListener( 'keyup', ( e ) => {
            if ( (e.metaKey || e.ctrlKey) && ( String.fromCharCode(e.which).toLowerCase() === 'g') ) {
                this.toggle();
            }
        });

        console.log('Init Grid Helper');
    },

    toggle(){
        this.GridActive = ! this.GridActive;

        localStorage.setItem( 'grid-helper-active', this.GridActive ? 'true' : 'false' );
    }


}));